import { useState } from "react";
import useLoading from "./useLoading";

function useModal() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editing, setEditing] = useState(false);
  const [id, setId] = useState<number>();
  const [current, setCurrent] = useState<any>();
  const loading = useLoading();

  const openModal = () => {
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };

  return {
    closeModal,
    current,
    editing,
    id,
    isLoading: loading.loading,
    isModalOpen,
    loading,
    openModal,
    setCurrent,
    setEditing,
    setId,
  };
}

export default useModal;
